export default "__VITE_ASSET__BJ9lTUG4__"